// @flow

import * as React from 'react';
import {useAccount} from 'docs/data';
import {SidebarContainer} from './SidebarContainer';
import {SidebarNavigation} from './navigation/SidebarNavigation';
import {SidebarFooter} from './footer/SidebarFooter';

export const Sidebar = () => {
  const {account} = useAccount();

  if (account.xray) {
    // X-Ray support is conditionally loaded only for Stripe employees.
    const {XRaySidebar} = require('./xray/XRaySidebar');
    return <XRaySidebar />;
  }

  return (
    <SidebarContainer background="white">
      <SidebarNavigation />
      <SidebarFooter />
    </SidebarContainer>
  );
};
